import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './delete-user-banner-primary-influencer.scss';

applyTranslations(require('./delete-user-banner-primary-influencer.i18n.json'));

const MSG_KEY = 'delete_user_banner_primary_influencer';

const DeleteUserBannerPrimaryInfluencer = (): JSX.Element => (
  <div className="delete-user-banner-primary-influencer">
    <div className="delete-user-banner-primary-influencer__title">
      {__t(`${MSG_KEY}.title`)}
    </div>
    <div className="delete-user-banner-primary-influencer__subtitle">
      {__t(`${MSG_KEY}.subtitle`)}
    </div>
    <ul className="delete-user-banner-primary-influencer__bullets">
      <li>
        {__t(`${MSG_KEY}.bullets.one`)}
      </li>
      <li>
        {__t(`${MSG_KEY}.bullets.two`)}
      </li>
      <li>
        {__t(`${MSG_KEY}.bullets.three`)}
      </li>
    </ul>
    <div className="delete-user-banner-primary-influencer__disclaimer">
      {__t(`${MSG_KEY}.disclaimer`)}
    </div>
  </div>
);

export default DeleteUserBannerPrimaryInfluencer;
